export const TEMPLATE_IMAGES_BASE_KEY = 'template-images';

export const templateImagesApiQueryKeys = {
  all: () => [TEMPLATE_IMAGES_BASE_KEY] as const,
};
